
jQuery( document ).ready(function() {

    if ( $('.listcoupoles_parentselect').length ) {

        var id_taxanomy = $("#coupolesByDate").val();
        var child_select = 0;
        getCoupoles(id_taxanomy, child_select);

        $('#coupolesByDate').on('change', function (e) {
            e.preventDefault();
            var id_taxanomy = $(this).val();
            var child_select = 0;
            getCoupoles(id_taxanomy, child_select);
        });

        $(document).on('change', '#coupolesByType', function(e) {
            e.preventDefault();
            var id_taxanomy = $(this).val();
            var child_select = 1;
            getCoupoles(id_taxanomy, child_select);
        });

        function getCoupoles(id_taxanomy, child_select) {
            
            if (child_select != 1) {
                $(".listcoupoles_childselect").html("");
            }
            
            $(".listcoupoles_listarticles").html("");
            $(".listcoupoles_programme").html("");
            $('body').append( "<div class='loader'></div>" );
            $('.div_modal_light').addClass( "visible" );

            $.ajax({
                type: 'POST',
                url: ajax_auth_object.ajaxurl,
                dateType: 'JSON', 
                data: {
                action: "fetch_couploes",
                id_taxanomy:id_taxanomy, 
                },
                success: function(data) {
                    var success = $.parseJSON(data);
                    if (child_select != 1) {
                        $(".listcoupoles_childselect").append(success.child_select);
                    }
                    
                    $(".listcoupoles_programme").append(success.content_programme);
                    $(".listcoupoles_listarticles").append(success.content);
                    $('.loader').remove();
                    $('.div_modal_light').removeClass( "visible" );
                }
            });
        } 
    }  
});